import CourseSupervisorContainer from '../components/course_supervisor_container';

/* @ngInject */
export default function CourseSupervisorDashboardController($scope, CurrentUserManager) {
  $scope.CourseSupervisorDashboard = CourseSupervisorContainer;
  $scope.CurrentUserManager = CurrentUserManager;
}
